import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll<HTMLElement>('.js-slider');

  sliders.forEach((elem) => {
    let autoplay = elem.dataset.autoplay;
    let watchCSS = elem.dataset.watchcss;
    let center = elem.dataset.center;
    let centerMobile = elem.dataset.centermobile;
    let pageDots = elem.dataset.pagedots;
    let wrap = elem.dataset.wrap;
    let draggable = elem.dataset.draggable;
    let clickable = elem.dataset.clickable;
    let groupCells = elem.dataset.groupcells;
    let contain = elem.dataset.contain;

    center = center ? center : !window.matchMedia('(min-width: 768px)').matches && centerMobile ? 'true' : undefined;

    let slider = new Flickity(elem, {
      cellSelector: '.js-slide',
      wrapAround: wrap ? true : false,
      lazyLoad: 2,
      imagesLoaded: true,
      cellAlign: center ? 'center' : 'left',
      pageDots: pageDots ? true : false,
      prevNextButtons: false,
      selectedAttraction: 0.018,
      adaptiveHeight: false,
      autoPlay: autoplay ? parseInt(autoplay) : false,
      watchCSS: watchCSS ? true : false,
      groupCells: groupCells,
      contain: contain,
      draggable: draggable ? true : false,
    });

    let prev = elem.querySelector('.js-prev');
    let next = elem.querySelector('.js-next');

    prev?.addEventListener('click', () => {
      slider.previous();
    });

    next?.addEventListener('click', () => {
      slider.next();
    });

    slider.on('change', () => {
      const slides = slider.slides;
      if (slides.length <= 2 || !wrap) {
        let numSlides = slides.length;
        let index = slider.selectedIndex;

        if (index === 0) {
          prev?.setAttribute('disabled', 'true');
          next?.removeAttribute('disabled');
        } else if (index === numSlides - 1) {
          prev?.removeAttribute('disabled');
          next?.setAttribute('disabled', 'true');
        } else {
          prev?.removeAttribute('disabled');
          next?.removeAttribute('disabled');
        }
      }
    });

    let raf: number | null = null;

    const handleRecalc = () => {
      if (raf) {
        cancelAnimationFrame(raf);
      }
      raf = requestAnimationFrame(() => {
        slider.reloadCells();
        slider.resize();
      });
    };

    // lazysizes fires this BEFORE loading (good for width changes)
    document.addEventListener('lazybeforeunveil', (e) => {
      const target = e.target as HTMLElement | null;
      if (target && elem.contains(target)) {
        handleRecalc();
      }
    });

    // lazysizes fires this AFTER loading (good for height changes)
    document.addEventListener('lazyloaded', (e) => {
      const target = e.target as HTMLElement | null;
      if (target && elem.contains(target)) {
        handleRecalc();
      }
    });

    if (clickable) {
      slider.on('staticClick', function(_event, _pointer, _cellElement, cellIndex) {
        if (typeof cellIndex === 'number') {
          slider.selectCell(cellIndex);
        }
      });
    }

    const updateControlsVisibility = () => {
      const totalSlides = elem.querySelectorAll('.js-slide').length;

      const slide = elem.querySelector('.js-slide') as HTMLElement;
      const slideWidth = slide?.offsetWidth || 1; // prevent divide-by-zero
      const sliderWidth = elem.offsetWidth;

      let visibleSlides = Math.floor(sliderWidth / slideWidth);
      let groupSize = 1;

      if (groupCells === 'true') {
        groupSize = visibleSlides;
      } else if (groupCells && !isNaN(Number(groupCells))) {
        groupSize = Number(groupCells);
      }

      const isHidden = totalSlides <= groupSize;

      elem.classList.toggle('slider--hide-controls', isHidden);
    };

    updateControlsVisibility();
    window.addEventListener('resize', updateControlsVisibility);
  });
});

// adds resize class for making slides same height
Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.create._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

let resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call(this);
  this.element.classList.add('flickity-resize');
};
